import React from "react"
import PropTypes from "prop-types"

import { Script } from "gatsby"

import * as blogPostToCStyles from "../styles/BlogPostToC.module.css"

export default function BlogPostToC(props) {
  const { headings } = props

  return (
    <>
      <div className={`row ${blogPostToCStyles.wrapper}`}>
        <div className={`d-none d-lg-block cubewise-post-side-nav-toc-wrapper`}>
          <ul className={`cubewise-post-side-nav-toc ${blogPostToCStyles.listing}`}>
            {headings && headings.map((heading, idx) => (
              <li
                key={idx}
                className={`toc-entry toc-entry-level${heading.level} ${blogPostToCStyles.item}`}
              >
                <a href={`#${heading.id}`}>{heading.text}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Script>{`
      window.cubewise = {}

      window.cubewise.tocItems = [].slice.call(
        document.querySelector(".cubewise-post-side-nav-toc").querySelectorAll("li.toc-entry")
      );
  
      // Cache element references and measurements
      window.cubewise.tocItems = window.cubewise.tocItems.map(function (item) {
        var anchor = item.querySelector("a");
        var target = document.getElementById(
          anchor.getAttribute("href").slice(1)
        );
  
        return {
          listItem: item,
          anchor: anchor,
          target: target,
        };
      });
  
      // Remove missing targets
      window.cubewise.tocItems = window.cubewise.tocItems.filter(function (item) {
        return !!item.target;
      });

      window.cubewise.sync = function() {
        var TOP_MARGIN = -0.1,
            BOTTOM_MARGIN = 0.2;
        var windowHeight = window.innerHeight;

        var alreadyOneSet = false;
        window.cubewise.tocItems.forEach(function (item) {
          var targetBounds = item.target.getBoundingClientRect();

          if (
            targetBounds.bottom > windowHeight * TOP_MARGIN &&
            targetBounds.top < windowHeight * (1 - BOTTOM_MARGIN) &&
            !alreadyOneSet
          ) {
            item.listItem.classList.add("visible");
            alreadyOneSet = true;
          } else {
            item.listItem.classList.remove("visible");
          }
        });
      }

      window.addEventListener("scroll", window.cubewise.sync, false)
      window.cubewise.sync()
      `}</Script>
    </>
  )
}

BlogPostToC.propTypes = {
  headings: PropTypes.arrayOf(
    PropTypes.shape({
      level: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
}
